import 'intersection-observer';
import * as React from 'react';

import { logError } from 'utils/log';

type Props = {
  className?: string,
  children?: React.ReactNode,
  onTrigger: () => void
};

class ViewportTracker extends React.PureComponent<Props> {
  observer: IntersectionObserver | null = null;
  indicator = React.createRef<HTMLDivElement>();

  componentDidMount(): void {
    try {
      if (this.indicator.current) {
        this.observer = new IntersectionObserver(this.handleIntersection); // eslint-disable-line no-undef
        this.observer.observe(this.indicator.current);
      }
    } catch (e) {
      logError(e);
    }
  }

  componentWillUnmount(): void {
    try {
      if (this.observer) {
        this.observer.disconnect();
      }
    } catch (e) {
      logError(e);
    }
  }

  handleIntersection = (entries: Array<IntersectionObserverEntry>) => {
    if (entries.some((entry) => entry.intersectionRatio > 0)) {
      // run only if intersecting with viewport
      this.handleLoadMore();
    }
  };

  handleLoadMore = () => {
    const { onTrigger } = this.props;
    onTrigger();
  };

  render() {
    const { children, className } = this.props;

    return (
      <div
        className={className}
        ref={this.indicator}
      >
        {children}
      </div>
    );
  }
}

export default ViewportTracker;
